module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0129.jpg?v=3eacef22";